import React, { useContext } from 'react';
import LazyLoading from '../../../components/LazyLoading';
import { DispatchProgramsStatus, DispatchProgramStatus } from '../../../app/models/DispatchProgram';
import { DispatchProgramStatusEnum } from '../../../app/shared/enums';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useDispatchProgramService from '../../../app/services/hooks/useDispatchProgramService';
import { toast } from 'react-toastify';

interface Props {
    dispatchProgramId: number;
    statuses: DispatchProgramsStatus[];
    status: string;
    reloadModule: () => void;
}

const DispatchProgramChangeStatusEdit = ({
    dispatchProgramId,
    statuses,
    status,
    reloadModule
}: Props) => {

    const { showLoading, hideLoading } = useContext(AppContext);

    const {
        fetchingCanChangeDispatchProgram,
        canChangeStatusDispatchProgram,
        changeStatusDispatchProgram,
        changeToDispatchStatusDispatchProgram,
        changeToFinishStatusDispatchProgram,
        changeToNullifiedStatusDispatchProgram
        
 
    } = useDispatchProgramService();

    const changeStatus = (status: string) => {
        if(!dispatchProgramId) return null
        if (showLoading) showLoading('loading', 'cargando..');

        canChangeStatusDispatchProgram(dispatchProgramId, status, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                confirmChange(status, dispatchProgramId, response.data.message);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
                toast.error(response.message);
            }
        });
    };

    const serviceEvent = {
        onSuccess: (response: ServiceResponse) => {
            if (hideLoading) hideLoading();

            useReactConfirmAlert().successAlert({
                title: 'Éxito',
                message: response.message
            });

            if(reloadModule) reloadModule();
        },
        onError: (response: ServiceResponse) => {
            if (hideLoading) hideLoading();

            useReactConfirmAlert().errorAlert({
                title: 'Error',
                message: response.message
            });
        }
    }


    const confirmChange = (status: string, dispatchProgramId: number, message: string) => {
        const obj = {'status': status}
        const _text = message;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, cambiar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Actualizando estado...');
                        // changeMonthlyClosureDetailsStatus(detailId, obj, serviceEvent);
                        switch (status) {
                            case DispatchProgramStatusEnum.DESPACHO:
                                changeToDispatchStatusDispatchProgram(dispatchProgramId, status, serviceEvent);
                                break;
                            case DispatchProgramStatusEnum.FINALIZADO:
                                changeToFinishStatusDispatchProgram(dispatchProgramId, status, serviceEvent);
                                break;
                            case DispatchProgramStatusEnum.ANULAR:
                                changeToNullifiedStatusDispatchProgram(dispatchProgramId, serviceEvent);
                                break;
                            default:
                                if (hideLoading) hideLoading();
                                setTimeout(() => {
                                    useReactConfirmAlert().infoAlert({
                                        title: 'Cancelado',
                                        message: 'Opción no encontrada.'
                                    });
                                }, 0);
                                break;
                        }
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El detalle de cierre no se ha cambiado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    }
    
    const parseStatusToName = (state: string) => {
        const statusObj = statuses.find((s) => s.id === state);
        return statusObj ? statusObj.name : '';
    };

    const nextStatus = (state: string) => {
        const transitionObj = statuses.find((s) => s.id === state);
        return transitionObj ? String(transitionObj.next) : '';
    };

    const prevStatus = (state: string) => {
        const transitionObj = statuses.find((s) => s.id === state);
        return transitionObj ? String(transitionObj.prev) : '';
    };

    return (
        <div className="row justify-content-center align-items-center">
            <div className="row sticky-status">
                <div className="col-4 text-center">
                    {parseStatusToName(prevStatus(String(status))) !== '' && (
                        <>
                            <div className="h3 mt-0 mb-2 card-title">Anterior Estado</div>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    changeStatus(prevStatus(String(status)));
                                }}
                            >
                                {parseStatusToName(prevStatus(String(status)))}
                            </button>
                        </>
                    )}
                </div>

                <div className="col-4 text-center">
                    <div className="h3 mt-0 mb-2 card-title text-center">Estado actual</div>

                    <div className="h5 mt-0 mb-2 card-title text-center">
                        <strong>{parseStatusToName(String(status))}</strong>
                    </div>
                </div>

                <div className="col-4 float-end text-center">
                    {parseStatusToName(nextStatus(String(status))) !== '' && (
                        <>
                            <div className="h3 mt-0 mb-2 card-title text-center">
                                Siguiente Estado
                            </div>

                            <button
                                className={`btn btn-${nextStatus(String(status))!== DispatchProgramStatusEnum.ANULAR ? 'primary' : 'danger'} text-center mb-2`}
                                onClick={() => {
                                    changeStatus(nextStatus(String(status)));
                                }}
                            >
                                {parseStatusToName(nextStatus(String(status)))}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DispatchProgramChangeStatusEdit;
